(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/cookie-consent/assets/javascripts/cookie-consent.js') >= 0) return;  svs.modules.push('/components/core/cookie-consent/assets/javascripts/cookie-consent.js'); 'use strict';

svs.core = svs.core || {};
svs.core.cookie_consent = svs.core.cookie_consent || {};
svs.core.cookie_consent.data = svs.core.cookie_consent.data || {};

svs.core.cookie_consent.DataHandler = function () {
  const cookieName = 'cookie_consent';
  const cookieVersion = svs.core.cookie_consent.data.cookieVersion || 0;
  return {
    setConsent: config => {
      if (typeof config.ad !== 'boolean' || typeof config.personalized !== 'boolean') {
        return $.Deferred().reject(Error('Bad parameters'));
      }

      const cookieValue = {
        ad: config.ad,
        personalized: config.personalized,
        version: cookieVersion
      };
      return $.ajax({
        type: 'GET',
        cache: false,
        url: "/ss-cookie?name=".concat(encodeURIComponent(cookieName), "&value=").concat(encodeURIComponent(JSON.stringify(cookieValue)))
      });
    }
  };
};

svs.core.cookie_consent.dataHandler = new svs.core.cookie_consent.DataHandler();
 })(window);